import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ChunkReloadModalContent = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
      <CircularProgress size={16} />
      <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
        {t('widgets.update_banner.error_modal.title')}
      </Typography>
      <Box style={{ fontSize: '0.95rem', textAlign: 'center' }}>
        {t('widgets.update_banner.error_modal.description')}
      </Box>
    </Stack>
  );
};

export default ChunkReloadModalContent;
